import {
  ICredentialRequest,
  ICredentialResponse,
} from '../../pages/credentials/Credentials.interface';
import client from '../axios';

const getCredentials = async (): Promise<ICredentialResponse[]> =>
  client.get('/credentials/');

const deleteCredential = async ({ id }: ICredentialResponse): Promise<any> =>
  client.delete(`/credentials/${id}`);

const createCredential = async (
  request: ICredentialRequest
): Promise<ICredentialResponse> => client.post('/credentials/', request);

const CredentialSvc = {
  getCredentials,
  deleteCredential,
  createCredential,
};

export default CredentialSvc;
